import { fileNameFromUrl, useFileActions, printPdfBlob } from '../../../../features/files'
import { FileTile, FileType, Modal, ModalId, showErrorStrToast } from '../../../../features/ui'
import { DataType } from '../../../../tables'
import { DataValueType2 } from '../../../data-types'
import { useState } from 'react'

type Props = {
    modalId: ModalId
    dataType?: DataType | { [prop: string]: DataValueType2 }
    fileProp: keyof DataType
    title?: string
}

export const DownloadFileModal = (props: Props) => {
    const { modalId, dataType, fileProp, title } = props

    const fileUrl = dataType && dataType[fileProp] as string
    const fileName = fileNameFromUrl(fileUrl)

    const [isPrinting, setIsPrinting] = useState(false)

    const { downloadFile, fetchFile } = useFileActions()

    const onSubmit = () => {
        if (dataType && dataType[fileProp]) {
            downloadFile(dataType[fileProp] as string)
        }
    }

    const handlePrint = async () => {
        if (!fileUrl) return
        try {
            setIsPrinting(true)
            const blob = await fetchFile(fileUrl)
            await printPdfBlob(blob)
        } catch {
            showErrorStrToast('Error al cargar el archivo para imprimir.')
        } finally {
            setIsPrinting(false)
        }
    }

    return (
        <Modal
            modalId={modalId}
            title={title || 'Descargar Comprobante'}
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
            secondaryLabel="Imprimir"
            secondaryIcon="printer"
            disableSecondary={isPrinting || !fileUrl}
            onSecondarySubmit={handlePrint}
        >
            <FileTile
                fileType={FileType.PDF}
                fileName={fileName}
            />
        </Modal>
    )
}
